<template>
    <v-container fluid class="pa-4">
        <v-card>
            <v-card-title class="d-flex justify-space-between align-center">
                <span class="title">{{ $t('title.popisneAktivnosti') }}</span>
                <div class="d-flex">

                    <!-- Dodaj novi popis -->
                    <v-tooltip location="bottom" content-class="custom-tooltip">
                        <template #activator="{ props }">
                            <v-btn v-bind="props" size="small" variant="outlined" color="primary" class="action-btn"
                                icon="mdi-plus" type="button" @click="openNewPopis" />
                        </template>
                        {{ $t('general.dodajNoviPopis') }}
                    </v-tooltip>
                </div>
            </v-card-title>

            <v-card-text>
                <v-text-field v-model="search" prepend-inner-icon="mdi-magnify" class="mb-2" autocomplete="off"
                    density="compact" />

                <v-data-table :headers="headers" :items="filteredPopisi" :loading="loading"
                    :loading-text="$t('general.loading')" class="min-width-table custom-header" :items-per-page="15">
                    <template v-slot:headers="{ columns, toggleSort, isSorted, getSortIcon }">
                        <tr>
                            <th v-for="column in columns" :key="column.value"
                                @click="() => column.sortable && toggleSort(column)" :style="{
                                    cursor: column.sortable ? 'pointer' : 'default',
                                    width: column.width,
                                    maxWidth: column.width,
                                    textAlign: column.key === 'Actions' ? 'right' : column.align === 'center' ? 'center' : 'left'
                                }" class="sortable-header">
                                <div class="d-flex align-center w-100"
                                    :class="column.key === 'Actions' ? 'justify-end' : column.align === 'center' ? 'justify-center' : 'justify-space-between'">
                                    <strong>{{ column.title }}</strong>
                                    <v-icon v-if="column.sortable" size="12" class="sort-icon ml-2"
                                        :class="{ active: isSorted(column) }">
                                        {{ isSorted(column) ? getSortIcon(column) : 'mdi-arrow-up-down' }}
                                    </v-icon>
                                </div>
                            </th>
                        </tr>
                    </template>

                    <!-- REDNI BROJ -->
                    <template v-slot:[`item.index`]="{ index }">
                        {{ index + 1 }}
                    </template>

                    <!-- NAZIV POPISA -->
                    <template v-slot:[`item.Name`]="{ item }">
                        {{ item.Name }}
                    </template>

                    <!-- DATUM -->
                    <template v-slot:[`item.Date`]="{ item }">
                        {{ formatDate(item.Date) }}
                    </template>

                    <!-- STATUS -->
                    <template v-slot:[`item.Status`]="{ item }">
                        <v-chip :color="item.Status === false ? 'success' : 'error'" variant="tonal" size="small">
                            {{ item.Status === false ? $t('general.otvoren') : $t('general.zatvoren') }}
                        </v-chip>
                    </template>

                    <!-- DOKUMENTI -->
                    <template v-slot:[`item.Documents`]="{ item: popisItem }">
                        <div class="d-flex flex-column ga-1 py-1">
                            <div v-if="!popisItem.Dokumenti || popisItem.Dokumenti.length === 0"
                                style="font-size:13px; color: #999;">
                                {{ $t('general.noDoc') }}
                            </div>
                            <div v-for="dok in popisItem.Dokumenti" :key="dok.Id" class="doc-row">
                                <a href="#" class="doc-link" @click.prevent="downloadFile(dok.FileName)">
                                    <v-icon size="16" class="mr-1">mdi-download</v-icon>
                                    {{ dok.Name }}
                                </a>

                                <div class="doc-actions">
                                    <v-tooltip location="bottom" content-class="custom-tooltip">
                                        <template #activator="{ props }">
                                            <v-btn v-bind="props" size="x-small" variant="text" color="primary"
                                                class="mr-2 action-btn-small" @click="openChangeDoc(popisItem, dok)"
                                                style="margin-right: -5px !important;">
                                                <v-icon size="14">mdi-pencil</v-icon>
                                            </v-btn>
                                        </template>
                                        {{ $t('general.editDokument') }}
                                    </v-tooltip>
                                    <v-tooltip location="bottom" content-class="custom-tooltip">
                                        <template #activator="{ props }">
                                            <v-btn v-bind="props" size="x-small" variant="text" color="red"
                                                class="mr-2 action-btn-small" @click="openDeleteDoc(popisItem, dok)">
                                                <v-icon size="14">mdi-delete</v-icon>
                                            </v-btn>
                                        </template>
                                        {{ $t('general.delete') }}
                                    </v-tooltip>
                                </div>
                            </div>
                        </div>
                    </template>

                    <!-- OPCIJE -->
                    <template v-slot:[`item.Actions`]="{ item }">
                        <div class="d-flex justify-end action-buttons">

                            <!-- PREGLEDAJ -->
                            <v-tooltip location="bottom" content-class="custom-tooltip">
                                <template #activator="{ props }">
                                    <v-btn v-bind="props" variant="outlined" color="primary" class="mr-2 action-btn"
                                        type="button" @click="pregledaj(item)">
                                        <v-icon size="16">mdi-eye-outline</v-icon>
                                    </v-btn>
                                </template>
                                {{ $t('general.viewPopis') }}
                            </v-tooltip>
                            <!-- Izvještaj -->
                            <v-tooltip location="bottom" content-class="custom-tooltip">
                                <template #activator="{ props }">
                                    <v-btn v-bind="props" size="small"
                                        variant="outlined" color="primary" class="action-btn mr-2"
                                        icon="mdi-file-chart-outline" type="button"
                                        @click="openIzvjestajDialog(item)" />
                                </template>
                                {{ $t('general.izvjestajOPopisu') }}
                            </v-tooltip>


                            <!-- Odluka -->
                            <v-tooltip location="bottom" content-class="custom-tooltip">
                                <template #activator="{ props }">
                                    <v-btn v-bind="props" size="small"
                                        variant="outlined" color="primary" class="action-btn mr-2" icon="mdi-gavel"
                                        type="button" @click="openOdlukaDialog(item)" /> </template>
                                {{ $t('general.odlukaOUsvajanju') }}
                            </v-tooltip>


                            <!-- EDITUJ -->
                            <v-tooltip location="bottom" content-class="custom-tooltip">
                                <template #activator="{ props }">
                                    <v-btn v-bind="props" variant="outlined"
                                        color="primary" class="mr-2 action-btn" type="button" @click="edituj(item)">
                                        <v-icon size="16">mdi-pencil</v-icon>
                                    </v-btn>
                                </template>
                                {{ $t('general.uredi') }}
                            </v-tooltip>

                            <!-- OBRIŠI -->
                            <v-tooltip location="bottom" content-class="custom-tooltip">
                                <template #activator="{ props }">
                                    <v-btn v-bind="props" size="small"
                                        variant="outlined" color="red" class="action-btn" type="button"
                                        @click="openDeleteDialog(item)">
                                        <v-icon size="16">mdi-delete</v-icon>
                                    </v-btn>
                                </template>
                                {{ $t('general.delete') }}
                            </v-tooltip>

                        </div>
                    </template>

                </v-data-table>
            </v-card-text>
        </v-card>

        <!-- DODAVANJE NOVOG POPISA -->
        <BaseModal v-model="dialog" :title="editMode ? $t('modalni.popis.uredi') : $t('modalni.popis.dodaj')" size="lg">
            <v-form ref="popisForm" v-model="isFormValid">

                <div class="d-flex ga-3">
                    <v-text-field v-model="form.Name" :label="$t('modalni.popis.naziv')" :rules="[rules.required]"
                        class="my-text" required style="flex: 2;" />

                    <v-text-field v-model="form.Date" type="date" :label="$t('modalni.popis.datumKreiranja')"
                        :rules="[rules.required]" class="my-text" required style="flex: 1;"
                        @update:model-value="checkDate" />
                </div>
                <!-- UPOZORENJE ZA DATUM -->
                <v-alert v-if="datumUpozorenje" type="warning" variant="tonal" density="compact" class="mb-3">
                    {{ $t('modalni.popis.datumUpozorenje') }}
                </v-alert>

                <!-- DOKUMENTI — kaskadno dodavanje -->
                <div v-for="(doc, index) in form.Documents" :key="index" class="d-flex align-center ga-2">
                    <div class="d-flex align-center ga-2" style="flex: 1;">
                        <v-text-field v-model="form.DocumentNames[index]"
                            :label="`${$t('modalni.popis.nazivDokumenta')} ${index + 1}`" class="my-text" />
                        <v-file-input v-model="form.Documents[index]"
                            :label="`${$t('modalni.popis.dokument')} ${index + 1}`" accept=".pdf,image/*"
                            prepend-icon="mdi-paperclip" class="my-text" clearable
                            @update:model-value="onDocumentAdded(index)" />
                    </div>
                    <v-btn v-if="index > 0" icon size="small" variant="text" color="red" @click="removeDocument(index)">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </div>

                <v-divider class="my-3" />

                <!-- KOMISIJA INFO -->
                <div v-if="komisija" style="font-size:14px;">
                    <div class="d-flex justify-space-between align-center mb-2">
                        <strong>{{ $t('modalni.popis.aktivnaKomisija') }}: {{ komisija.Name }}</strong>
                        <v-btn size="small" variant="text" color="primary" @click="$router.push({ name: 'Komisije' })">
                            {{ $t('modalni.popis.promijeniKomisiju') }}
                        </v-btn>
                    </div>
                    <div v-for="(clan, i) in komisijaMembers" :key="i" style="color:#555;">
                        <v-icon size="14" class="mr-1">mdi-account</v-icon>
                        {{ clan }}
                    </div>
                </div>
                <div v-else style="font-size:14px; color:#999;">
                    {{ $t('modalni.popis.nemaAktivneKomisije') }}
                    <v-btn size="small" variant="text" color="primary" @click="$router.push({ name: 'Komisije' })">
                        {{ $t('modalni.popis.promijeniKomisiju') }}
                    </v-btn>
                </div>

            </v-form>

            <template #footer>
                <div class="d-flex justify-end ga-2">
                    <v-btn variant="outlined" @click="closeDialog">
                        <span style="font-size:14px; font-weight:600;">{{ $t('general.cancel') }}</span>
                    </v-btn>
                    <v-btn color="primary" variant="flat" @click="savePopis">
                        <span style="font-size:14px; font-weight:600;">{{ $t('general.save') }}</span>
                    </v-btn>
                </div>
            </template>
        </BaseModal>

        <!-- BRISANJE POPISA -->
        <BaseModal v-model="deleteDialog" :title="$t('modalni.popis.brisi')">
            <p>{{ $t('modalni.popis.potvrdaBrisanja') }} <strong>{{ deletePopisName }}</strong>?</p>

            <template #footer>
                <div class="d-flex justify-end ga-2">
                    <v-btn variant="outlined" @click="deleteDialog = false">
                        <span style="font-size:14px; font-weight:600;">{{ $t('general.cancel') }}</span>
                    </v-btn>
                    <v-btn color="danger" variant="flat" @click="confirmDelete">
                        <span style="font-size:14px; font-weight:600; color:#FFF">{{ $t('general.deleteButton')
                            }}</span>
                    </v-btn>
                </div>
            </template>
        </BaseModal>

        <!-- Izvjestaj o opisu -->
        <BaseModal v-model="izvjestajDialog" :title="$t('general.izvjestajOPopisuUPPER')">
            <v-form>
                <v-text-field v-model="izvjestajDate" type="date" :label="$t('modalni.izvjestaji.izvjestajNaDan')"
                    class="my-text" />
            </v-form>
            <template #footer>
                <div class="d-flex justify-end ga-2">
                    <v-btn variant="outlined" @click="izvjestajDialog = false">
                        <span style="font-size:14px; font-weight:600;">{{ $t('general.cancel') }}</span>
                    </v-btn>
                    <v-btn color="primary" variant="flat" :disabled="!izvjestajDate" @click="confirmIzvjestaj">
                        <span style="font-size:14px; font-weight:600;">{{ $t('general.view') }}</span>
                    </v-btn>
                </div>
            </template>
        </BaseModal>

        <!-- Odluka o popisu -->
        <BaseModal v-model="odlukaDialog" :title="$t('general.odlukaOUsvajanjuUPPER')">
            <v-form>
                <v-text-field v-model="odlukaDate" type="date" :label="$t('modalni.izvjestaji.izvjestajNaDan')"
                    class="my-text" />
            </v-form>
            <template #footer>
                <div class="d-flex justify-end ga-2">
                    <v-btn variant="outlined" @click="odlukaDialog = false">
                        <span style="font-size:14px; font-weight:600;">{{ $t('general.cancel') }}</span>
                    </v-btn>
                    <v-btn color="primary" variant="flat" :disabled="!odlukaDate" @click="confirmOdluka">
                        <span style="font-size:14px; font-weight:600;">{{ $t('general.view') }}</span>
                    </v-btn>
                </div>
            </template>
        </BaseModal>

        <!-- PRINT PREVIEW -->
        <BaseModal v-model="reportPreview" size="xl" height="90vh" modalClass="report-modal" :hideFooter="true">
            <template #header-actions>
                <v-tooltip location="bottom" content-class="custom-tooltip" :text="$t('general.download')">
                    <template #activator="{ props }">
                        <v-btn v-bind="props" icon variant="plain" @click="downloadPDF">
                            <v-icon size="18"
                                style="padding-top: 2px !important; padding-left: 10px !important;">mdi-download</v-icon>
                        </v-btn>
                    </template>
                </v-tooltip>
                <v-tooltip v-if="!isOdlukaPreview" location="bottom" content-class="custom-tooltip"
                    :text="$t('general.print')">
                    <template #activator="{ props }">
                        <v-btn v-bind="props" icon variant="plain" @click="printReport">
                            <v-icon size="18">mdi-printer</v-icon>
                        </v-btn>
                    </template>
                </v-tooltip>
            </template>
            <iframe ref="reportFrame" :style="{
                width: '100%', height: '100%', border: 'none',
                transform: `scale(${zoom})`, transformOrigin: 'top left'
            }" />
        </BaseModal>
        <!-- PROMJENA DOKUMENTA POPISA -->
        <BaseModal v-model="changeDocDialog" :title="$t('general.editDokument')">
            <v-text-field v-model="docForm.name" :label="$t('modalni.popis.nazivDokumenta')" class="my-text" />
            <v-file-input v-model="docForm.file" :label="$t('modalni.popis.dokument')" prepend-icon="mdi-paperclip"
                accept=".pdf,image/*" class="my-text" />
            <template #footer>
                <div class="d-flex justify-end ga-2">
                    <v-btn variant="outlined" @click="changeDocDialog = false">
                        <span style="font-size:14px; font-weight:600;">{{ $t('general.cancel') }}</span>
                    </v-btn>
                    <v-btn color="primary" @click="confirmChangeDoc">
                        <span style="font-size:14px; font-weight:600;">{{ $t('general.potvrdi') }}</span>
                    </v-btn>
                </div>
            </template>
        </BaseModal>

        <!-- BRISANJE DOKUMENTA POPISA -->
        <BaseModal v-model="deleteDocDialog" :title="$t('general.deleteDoc')">
            <p>{{ $t('modalni.popis.potvrdaBrisanjaDokumenta') }} <strong>{{ docToDelete?.Name }}</strong>?</p>
            <template #footer>
                <div class="d-flex justify-end ga-2">
                    <v-btn variant="outlined" @click="deleteDocDialog = false">
                        <span style="font-size:14px; font-weight:600;">{{ $t('general.cancel') }}</span>
                    </v-btn>
                    <v-btn color="danger" variant="flat" @click="confirmDeleteDoc">
                        <span style="font-size:14px; font-weight:600; color:#FFF">{{ $t('general.deleteButton')
                        }}</span>
                    </v-btn>
                </div>
            </template>
        </BaseModal>
        <!-- PREVIEW DOKUMENTA -->
        <BaseModal v-model="docPreviewDialog" size="xl" height="90vh" :title="docPreviewFileName"
            modalClass="report-modal" :hideFooter="true" @update:modelValue="val => { if (!val) closeDocPreview() }">
            <template #header-actions>
                <v-tooltip location="bottom" content-class="custom-tooltip" :text="$t('general.download')">
                    <template #activator="{ props }">
                        <v-btn v-bind="props" icon variant="plain" @click="downloadDocFromPreview">
                            <v-icon size="18" style="padding-left: 10px;">mdi-download</v-icon>
                        </v-btn>
                    </template>
                </v-tooltip>
                <v-tooltip location="bottom" content-class="custom-tooltip" :text="$t('general.print')">
                    <template #activator="{ props }">
                        <v-btn v-bind="props" icon variant="plain" @click="printDocFromPreview">
                            <v-icon size="18">mdi-printer</v-icon>
                        </v-btn>
                    </template>
                </v-tooltip>
            </template>
            <iframe ref="docPreviewFrame" :src="docPreviewUrl" style="width:100%; height:100%; border:none;" />
        </BaseModal>
    </v-container>
</template>

<script>
import { fetchHeaderImage } from "@/services/printService";
import { format } from "date-fns"
import BaseModal from '@/components/dialogs/BaseModal.vue'
import * as mammoth from 'mammoth'
import {
    Document, Packer, Paragraph, TextRun, Table, TableRow, TableCell,
    AlignmentType, BorderStyle, WidthType, Header, ImageRun, LevelFormat
} from 'docx'
import html2pdf from "html2pdf.js"

export default {
    name: 'PopisneAktivnostiPage',
    components: { BaseModal },
    watch: {
        reportPreview(val) {
            if (!val) {
                this.isOdlukaPreview = false
                this._izvjestajBlob = null
                this._izvjestajFileName = null
            }
        },
        docPreviewDialog(val) {
            if (!val) this.closeDocPreview()
        }
    },
    data() {
        return {
            docPreviewDialog: false,
            docPreviewUrl: null,
            docPreviewFileName: null,
            docPreviewBlob: null,
            changeDocDialog: false,
            deleteDocDialog: false,
            docForm: {
                file: null,
                name: '',
                docId: null,
                popisId: null,
            },
            docToDelete: null,
            datumUpozorenje: false,
            izvjestajDialog: false,
            izvjestajDate: null,
            odlukaDialog: false,
            odlukaDate: null,
            currentPopis: null,
            isOdlukaPreview: false,
            komisija: null,
            reportTitle: '',
            loading: false,
            search: '',
            editMode: false,
            editId: null,
            popisi: [],
            headers: [

                { title: this.$t('modalni.popis.naziv'), key: 'Name', sortable: true, width: "36%" },
                { title: this.$t('general.date'), align: 'center', key: 'Date', sortable: true, width: "10%" },
                { title: this.$t('general.status'), align: 'center', key: 'Status', sortable: true, width: "100px" },
                { title: this.$t('general.dokumenti'), key: 'Documents', sortable: false, width: 'calc(57% - 240px)' },
                { title: this.$t('general.optionsUPPER'), key: 'Actions', sortable: false, width: "240px" },
            ],
            dialog: false,
            isFormValid: false,
            deleteDialog: false,
            deletePopisId: null,
            deletePopisName: '',
            reportPreview: false,
            zoom: 1,
            html: '',
            form: {
                Name: '',
                Date: null,
                Documents: [null],
                DocumentNames: [''],
            },
            rules: {
                required: v => (v !== null && v !== undefined && v !== '') || this.$t('systemMessage.m1')
            }
        }
    },

    computed: {
        isCyrillic() {
            return localStorage.getItem('LanguageId') === '1'
        },
        komisijaMembers() {
            if (!this.komisija?.Members) return []
            return this.komisija.Members.split('\n').map(m => m.trim()).filter(Boolean)
        },
        filteredPopisi() {
            const term = this.search.toLowerCase().trim()

            let data = this.popisi

            if (term) {
                data = this.popisi.filter(p =>
                    Object.values(p).some(val =>
                        String(val ?? '').toLowerCase().includes(term)
                    )
                )
            }
            // (najnoviji je prvi)
            return [...data].sort((a, b) => new Date(b.Date) - new Date(a.Date))
        }
    },

    async mounted() {
        await this.fetchPopisi()
    },

    methods: {
          async getHeaderImage() {
            return await fetchHeaderImage(this.$axios)
        },
        downloadDocFromPreview() {
            if (!this.docPreviewUrl) return
            const link = document.createElement('a')
            link.href = this.docPreviewUrl
            link.setAttribute('download', this.docPreviewFileName)
            document.body.appendChild(link)
            link.click()
            document.body.removeChild(link)
        },

        printDocFromPreview() {
            this.$refs.docPreviewFrame?.contentWindow?.print()
        },

        closeDocPreview() {
            if (this.docPreviewUrl) window.URL.revokeObjectURL(this.docPreviewUrl)
            this.docPreviewDialog = false
            this.docPreviewUrl = null
            this.docPreviewFileName = null
            this.docPreviewBlob = null
        },
        openChangeDoc(popisItem, dok) {
            this.docForm = {
                file: null,
                name: dok.Name,
                docId: dok.Id,
                popisId: popisItem.Id,
            }
            this.changeDocDialog = true
        },

        async confirmChangeDoc() {
            if (!this.docForm.file) return

            const now = new Date()
            const m = String(now.getUTCMonth() + 1).padStart(2, '0')
            const d = String(now.getUTCDate()).padStart(2, '0')
            const y = now.getUTCFullYear().toString().slice(-2)
            const h = String(now.getHours()).padStart(2, '0')
            const min = String(now.getMinutes()).padStart(2, '0')
            const s = String(now.getSeconds()).padStart(2, '0')
            const ext = this.docForm.file.name.split('.').pop()
            const fileName = `Popis_${localStorage.getItem('CountryId')}_${localStorage.getItem('CompanyId')}_${m}${d}${y}${h}${min}${s}.${ext}`

            try {
                // Upload fajla
                const file = new File([this.docForm.file], fileName, { type: this.docForm.file.type })
                const formData = new FormData()
                formData.append('file', file)
                await this.$axios.post('Upload/', formData)

                // Ažuriraj zapis
                await this.$axios.put('Popis/EditDokument', {
                    Id: this.docForm.docId,
                    Name: this.docForm.name,
                    FileName: fileName,
                    CompanyId: Number(localStorage.getItem('CompanyId'))
                })

                this.$store.dispatch('NOTIF_SUCCESS', {
                    poruka: this.$t('User_message.m138'),
                    position: 'top-end',
                    timer: 2500,
                    action: 'noreload'
                })

                this.changeDocDialog = false
                this.docForm = { file: null, docId: null, popisId: null }
                await this.fetchPopisi()

            } catch (err) {
                console.error(err)
                this.$store.dispatch('NOTIF_WARNING', {
                    poruka: this.$t('User_message.m139'),
                    position: 'center',
                    icon: 'error',
                    timer: 4500
                })
            }
        },

        openDeleteDoc(popisItem, dok) {
            this.docToDelete = { ...dok, popisId: popisItem.Id }
            this.deleteDocDialog = true
        },

        async confirmDeleteDoc() {
            if (!this.docToDelete) return

            try {
                await this.$axios.put('Popis/DeleteDokument', {
                    Id: this.docToDelete.Id,
                    CompanyId: Number(localStorage.getItem('CompanyId'))
                })

                this.$store.dispatch('NOTIF_SUCCESS', {
                    poruka: this.$t('User_message.m141'),
                    position: 'top-end',
                    timer: 2500,
                    action: 'noreload'
                })

                this.deleteDocDialog = false
                this.docToDelete = null
                await this.fetchPopisi()

            } catch (err) {
                console.error(err)
                this.$store.dispatch('NOTIF_WARNING', {
                    poruka: this.$t('User_message.m142'),
                    position: 'center',
                    icon: 'error',
                    timer: 4500
                })
            }
        },

        onDocumentAdded(index) {
            if (this.form.Documents[index] && index === this.form.Documents.length - 1) {
                this.form.Documents.push(null)
                this.form.DocumentNames.push('')
            }
        },

        removeDocument(index) {
            this.form.Documents.splice(index, 1)
            this.form.DocumentNames.splice(index, 1)
        },
        checkDate(val) {
            if (!val) { this.datumUpozorenje = false; return }
            const selected = new Date(val)
            const oneYearAgo = new Date()
            oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1)
            this.datumUpozorenje = selected < oneYearAgo
        },
        confirmIzvjestaj() {
            this.izvjestajDialog = false
            this.downloadIzvjestajDocx(this.izvjestajDate)
        },
        async downloadFile(url) {
            if (!url) return
            try {
                const res = await this.$axios.get('Upload?fileName=' + url, { responseType: 'arraybuffer' })
                const isImage = /\.(png|jpg|jpeg|webp|gif)$/i.test(url)
                const mimeType = isImage ? 'image/' + url.split('.').pop().toLowerCase() : 'application/pdf'
                const blob = new Blob([res.data], { type: mimeType })
                this.docPreviewUrl = window.URL.createObjectURL(blob)
                this.docPreviewFileName = url
                this.docPreviewBlob = blob
                this.docPreviewDialog = true
            } catch (err) {
                console.error(err)
            }
        },
        async fetchPopisi() {
            this.loading = true
            try {
                const r = await this.$axios.post('Popis/Show', {
                    Id: Number(localStorage.getItem('CompanyId')),
                    LanguageId: Number(localStorage.getItem('LanguageId'))
                })
                this.popisi = r.data || []
            } catch (err) {
                console.error(err)
                this.popisi = []
            } finally {
                this.loading = false
            }
        },
        formatDate(dateStr) {
            if (!dateStr) return "";
            try {
                return format(new Date(dateStr), "dd.MM.yyyy");
            } catch {
                return dateStr;
            }
        },

        formatMoney(v) {
            return Number(v || 0).toLocaleString("sr-Latn-BA", { minimumFractionDigits: 2, maximumFractionDigits: 2 })
        },

        openOdlukaDialog(item) {
            this.currentPopis = item
            this.odlukaDate = new Date().toISOString().split('T')[0]
            this.odlukaDialog = true
        },

        openIzvjestajDialog(item) {
            this.currentPopis = item
            this.izvjestajDate = new Date().toISOString().split('T')[0]
            this.izvjestajDialog = true
        },

        confirmOdluka() {
            this.odlukaDialog = false
            this.downloadOdlukaDocx(this.odlukaDate)
        },

        //ODLUKA
        async downloadOdlukaDocx(date) {
            const headerImageUrl = await this.getHeaderImage()
            const data = {
                Id: Number(localStorage.getItem('CompanyId')),
                LanguageId: Number(localStorage.getItem('LanguageId')),
                Date: date,
                StatusIds: [1, 2, 4]
            }
            const r = await this.$axios.post('Asset/ShowAssetPerKonto_Kumulativno', data)
            const podaci = r.data || []

            // Fetch za prijedlog rashoda OS
            const rRashodOS = await this.$axios.post('Asset/ShowAssetPerKonto_Kumulativno', {
                Id: Number(localStorage.getItem('CompanyId')),
                LanguageId: Number(localStorage.getItem('LanguageId')),
                Date: date,
                StatusIds: [4]
            })
            const podaciRashodOS = rRashodOS.data || []
            const totalRashodOS_Nabavna = podaciRashodOS.reduce((s, k) => s + Number(k.PurchaseValue || 0), 0)
            const totalRashodOS_Ispravka = podaciRashodOS.reduce((s, k) => s + Number(k.TotalDepreciation || 0), 0)
            const totalRashodOS_Sadasnja = podaciRashodOS.reduce((s, k) => s + Number(k.CurrentValue || 0), 0)

            // Fetch za prijedlog rashoda SI
            const rRashodSI = await this.$axios.post('SmallAsset/ShowSmallAssetPerKonto_Kumulativno', {
                Id: Number(localStorage.getItem('CompanyId')),
                LanguageId: Number(localStorage.getItem('LanguageId')),
                Date: date,
                StatusIds: [4]
            })
            const podaciRashodSI = rRashodSI.data || {}

            if (!this.komisija) await this.fetchKomisija()

            const stanjeDan = new Date(date).toLocaleDateString('sr-Latn-BA')
            const font = 'Times New Roman'
            const sz = 22
            const border = { style: BorderStyle.SINGLE, size: 1, color: 'auto' }
            const borders = { top: border, bottom: border, left: border, right: border }
            const fmt = v => Number(v || 0).toLocaleString('sr-Latn-BA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })

            const totalNabavna = podaci.reduce((s, k) => s + Number(k.PurchaseValue || 0), 0)
            const totalIspravka = podaci.reduce((s, k) => s + Number(k.TotalDepreciation || 0), 0)
            const totalSadasnja = podaci.reduce((s, k) => s + Number(k.CurrentValue || 0), 0)

            const p = (text, opts = {}) => new Paragraph({
                spacing: { line: 240 },
                alignment: opts.align || AlignmentType.LEFT,
                numbering: opts.numbering || undefined,
                children: [new TextRun({ text: text || ' ', font, size: sz, bold: !!opts.bold })]
            })

            const empty = () => p(' ')

            const tc = (text, align = AlignmentType.CENTER, bold = false, colspan = 1) => new TableCell({
                borders,
                columnSpan: colspan,
                margins: { top: 0, bottom: 0, left: 10, right: 10 },
                children: [new Paragraph({
                    alignment: align,
                    children: [new TextRun({ text: text || '', font, size: sz, bold })]
                })]
            })

            // Tabela stalnih sredstava po kontima
            const colWidths5 = [1400, 2500, 1800, 1800, 1800]
            const stalnaSredstvaRows = [
                new TableRow({
                    children: [
                        tc(this.$t('report.odluka.konto'), AlignmentType.LEFT, true),
                        tc(this.$t('report.odluka.kategorija'), AlignmentType.CENTER, true),
                        tc(this.$t('report.odluka.nabavnaVr'), AlignmentType.CENTER, true),
                        tc(this.$t('report.odluka.ispravkaVr'), AlignmentType.CENTER, true),
                        tc(this.$t('report.odluka.sadasnjaVr'), AlignmentType.CENTER, true),
                    ]
                }),
                ...podaci.map(k => {
                    const parts = (k.Category || '').split(' ')
                    const konto = parts[0] || ''
                    const naziv = parts.slice(1).join(' ') || k.Category || ''
                    return new TableRow({
                        children: [
                            tc(konto, AlignmentType.LEFT),
                            tc(naziv, AlignmentType.LEFT),
                            tc(fmt(k.PurchaseValue), AlignmentType.RIGHT),
                            tc(fmt(k.TotalDepreciation), AlignmentType.RIGHT),
                            tc(fmt(k.CurrentValue), AlignmentType.RIGHT),
                        ]
                    })
                }),
                new TableRow({
                    children: [
                        tc('', AlignmentType.LEFT),
                        tc(this.$t('report.odluka.ukupno'), AlignmentType.LEFT, true),
                        tc(fmt(totalNabavna), AlignmentType.RIGHT, true),
                        tc(fmt(totalIspravka), AlignmentType.RIGHT, true),
                        tc(fmt(totalSadasnja), AlignmentType.RIGHT, true),
                    ]
                })
            ]

            // Tabela rashoda (OS i SI)
            const colWidths4 = [1400, 2500, 2000, 2000]
            const rashodTable = (nabavna, ispravka, sadasnja, kategorije = []) => new Table({
                width: { size: 9906, type: WidthType.DXA },
                columnWidths: colWidths4,
                rows: [
                    new TableRow({
                        children: [
                            tc(''),
                            tc(this.$t('report.odluka.kategorija')),
                            tc(this.$t('report.odluka.nabavnaVrKM')),
                            tc(this.$t('report.odluka.ispravkaVrKM'))
                        ]
                    }),
                    ...kategorije.map(k => {
                        const parts = (k.Category || '').split(' ')
                        const naziv = parts.slice(1).join(' ') || k.Category || ''
                        return new TableRow({
                            children: [
                                tc(''),
                                tc(naziv, AlignmentType.LEFT),
                                tc(fmt(k.PurchaseValue), AlignmentType.RIGHT),
                                tc(fmt(k.TotalDepreciation), AlignmentType.RIGHT)
                            ]
                        })
                    }),
                    new TableRow({
                        children: [
                            tc(this.$t('report.odluka.stanjePoKnjigama'), AlignmentType.LEFT),
                            tc(''),
                            tc(fmt(nabavna), AlignmentType.RIGHT),
                            tc(fmt(ispravka), AlignmentType.RIGHT)
                        ]
                    }),
                    new TableRow({
                        children: [
                            tc(this.$t('report.odluka.stanjePoPopisu'), AlignmentType.LEFT),
                            tc(''),
                            tc(fmt(nabavna), AlignmentType.RIGHT),
                            tc(fmt(ispravka), AlignmentType.RIGHT)
                        ]
                    }),
                ]
            })

            // Tabela tuđih sredstava
            const tudaTable = () => new Table({
                width: { size: 9906, type: WidthType.DXA },
                columnWidths: [2721, 2511, 1664, 1510, 1500],
                rows: [
                    new TableRow({ children: [tc(this.$t('report.odluka.invBroj')), tc(this.$t('report.odluka.nazivSredstva')), tc(this.$t('report.odluka.barKod')), tc(this.$t('report.odluka.kolicina')), tc(this.$t('report.odluka.lokacija'))] }),
                    new TableRow({ children: [tc(''), tc(''), tc(''), tc(''), tc('')] }),
                ]
            })

            let logoHeader
            try {
                const logoResponse = await fetch(headerImageUrl)
                if (!logoResponse.ok) throw new Error('Logo error')
                const logoArrayBuffer = await logoResponse.arrayBuffer()
                logoHeader = new Header({
                    children: [new Paragraph({
                        alignment: AlignmentType.CENTER,
                        children: [new ImageRun({ data: logoArrayBuffer, transformation: { width: 530, height: 140 }, type: 'png' })]
                    })]
                })
            } catch (e) {
                logoHeader = new Header({ children: [new Paragraph({ children: [] })] })
            }

            const doc = new Document({
                numbering: {
                    config: [{
                        reference: 'lista',
                        levels: [{
                            level: 0, format: LevelFormat.DECIMAL, text: '%1.',
                            alignment: AlignmentType.LEFT,
                            style: { paragraph: { indent: { left: 720, hanging: 360 } } }
                        }]
                    }]
                },
                sections: [{
                    properties: {
                        page: {
                            size: { width: 11906, height: 16838 },
                            margin: { top: 720, right: 1000, bottom: 720, left: 1000 }
                        }
                    },
                    headers: { default: logoHeader },
                    children: [
                        p(this.$t('report.odluka.broj')),
                        p(`${this.$t('report.odluka.sarajevo')} ${stanjeDan} ${this.$t('report.odluka.godine')}`),
                        empty(),
                        p(this.$t('report.odluka.naOsnovu')),
                        empty(),
                        p(this.$t('report.odluka.naslov'), { bold: true, align: AlignmentType.CENTER }),
                        empty(),
                        p(this.$t('report.odluka.podnaslov'), { align: AlignmentType.CENTER }),
                        empty(),
                        p('I', { bold: true, align: AlignmentType.CENTER }),
                        p(`${this.$t('report.odluka.komisijaTekst')} ${stanjeDan} ${this.$t('report.odluka.godine')}.`),
                        empty(),
                        p(`${this.$t('report.odluka.popisUtvrdjeno')} ${stanjeDan}.`),
                        empty(),
                        new Table({
                            width: { size: 9906, type: WidthType.DXA },
                            columnWidths: colWidths5,
                            rows: stalnaSredstvaRows
                        }),
                        empty(),
                        p(this.$t('report.odluka.nakonSravnjenja')),
                        empty(),
                        p('II', { bold: true, align: AlignmentType.CENTER }),
                        p(`${this.$t('report.odluka.usvajaSe')} ${fmt(totalNabavna)} ${this.$t('report.odluka.iSadasnjom')} ${fmt(totalSadasnja)}.`),
                        empty(),
                        p(this.$t('report.odluka.nalazeSe')),
                        empty(),
                        p('III', { bold: true, align: AlignmentType.CENTER }),
                        p(`${this.$t('report.odluka.usvajaSeInventar')}`),
                        empty(),
                        p('IV', { bold: true, align: AlignmentType.CENTER }),
                        p(this.$t('report.odluka.prijedlogRashodaOS'), { bold: true }),
                        rashodTable(totalRashodOS_Nabavna, totalRashodOS_Ispravka, totalRashodOS_Sadasnja, podaciRashodOS),
                        empty(),
                        p(this.$t('report.odluka.prijedlogRashodaSI'), { bold: true }),
                        rashodTable(
                            podaciRashodSI.ukupnaNabavna || 0,
                            podaciRashodSI.amortizacija || 0,
                            podaciRashodSI.sadasnjaVrijednost || 0,
                            podaciRashodSI.ukupnaNabavna > 0
                                ? [{ Category: this.$t('general.sitniInventar'), PurchaseValue: podaciRashodSI.ukupnaNabavna, TotalDepreciation: podaciRashodSI.amortizacija }]
                                : []
                        ),
                        empty(),
                        p('V', { bold: true, align: AlignmentType.CENTER }),
                        p(this.$t('report.odluka.tudjaSredstva'), { bold: true }),
                        tudaTable(),
                        empty(),
                        p('VI', { bold: true, align: AlignmentType.CENTER }),
                        p(this.$t('report.odluka.uzOdluku')),
                        empty(),
                        p(this.$t('report.odluka.prilog1'), { numbering: { reference: 'lista', level: 0 } }),
                        p(this.$t('report.odluka.prilog2'), { numbering: { reference: 'lista', level: 0 } }),
                        p(this.$t('report.odluka.prilog3'), { numbering: { reference: 'lista', level: 0 } }),
                        p(this.$t('report.odluka.prilog4'), { numbering: { reference: 'lista', level: 0 } }),
                        p(this.$t('report.odluka.prilog5'), { numbering: { reference: 'lista', level: 0 } }),
                        p(this.$t('report.odluka.prilog6'), { numbering: { reference: 'lista', level: 0 } }),
                        empty(),
                        p(this.$t('report.odluka.generalniDirektor'), { align: AlignmentType.RIGHT }),
                        p('________________', { align: AlignmentType.RIGHT }),
                        empty(),
                        p(this.$t('report.odluka.dostavljeno')),
                        p(this.$t('report.odluka.dostavljeno1'), { numbering: { reference: 'lista', level: 0 } }),
                        p(this.$t('report.odluka.dostavljeno2'), { numbering: { reference: 'lista', level: 0 } }),
                    ]
                }]
            })

            const blob = await Packer.toBlob(doc)
            const d = new Date()
            const dateStr = String(d.getDate()).padStart(2, '0') + String(d.getMonth() + 1).padStart(2, '0') + d.getFullYear()
            this._izvjestajBlob = blob
            this._izvjestajFileName = `Odluka-o-usvajanju-popisa-${dateStr}.docx`

            const arrayBuffer = await blob.arrayBuffer()
            const result = await mammoth.convertToHtml({ arrayBuffer, options: { includeDefaultStyleMap: true } })

            const processedHtml = result.value
                .replace(/<p><strong>(I|II|III|IV|V|VI|VII|VIII|IX|X)<\/strong><\/p>/g,
                    '<p style="text-align:center;"><strong>$1</strong></p>')
                .replace(/<p>________________<\/p>/g,
                    '<p style="text-align:right;">________________</p>')
                // Latinica
                .replace(/<p>Generalni direktor<\/p>/g,
                    '<p style="text-align:right;">Generalni direktor</p>')
                // Ćirilica
                .replace(/<p>Генерални директор<\/p>/g,
                    '<p style="text-align:right;">Генерални директор</p>')
                .replace(/(<td>)(<p>)(\d[\d.]*,\d{2})(<\/p><\/td>)/g,
                    '<td style="text-align:right;"><p>$3</p></td>')
                .replace(/(<td>)(<p><strong>)(\d[\d.]*,\d{2})(<\/strong><\/p><\/td>)/g,
                    '<td style="text-align:right;"><p><strong>$3</strong></p></td>')
                // Latinica
                .replace(/<p><strong>ODLUKU<\/strong><\/p>/g,
                    '<p style="text-align:center;"><strong>ODLUKU</strong></p>')
                .replace(/<p>o usvajanju redovnog popisa/g,
                    '<p style="text-align:center;">o usvajanju redovnog popisa')
                // Ćirilica
                .replace(/<p><strong>ОДЛУКУ<\/strong><\/p>/g,
                    '<p style="text-align:center;"><strong>ОДЛУКУ</strong></p>')
                .replace(/<p>о усвајању редовног пописа/g,
                    '<p style="text-align:center;">о усвајању редовног пописа')
            let logoBase64 = ''
            try {
                const logoResponse = await fetch(headerImageUrl)
                const logoBlob = await logoResponse.blob()
                logoBase64 = await new Promise(resolve => {
                    const reader = new FileReader()
                    reader.onload = () => resolve(reader.result)
                    reader.readAsDataURL(logoBlob)
                })
            } catch (e) { console.warn('Logo nije učitan za preview') }

            const styledHtml = `<!DOCTYPE html><html><head><meta charset="UTF-8"><style>
@page{size:A4 portrait;}
*{box-sizing:border-box;margin:0;padding:0;}
.header-logo{position:fixed;top:0;left:0;right:0;text-align:center;background:white;}
.header-logo img{width:100%;max-width:530px;height:140px;object-fit:contain;}
.content{margin-top:160px;}
body{font-family:'Times New Roman',serif;font-size:11pt;line-height:1.67;color:#000;margin-top:12.7mm;margin-bottom:12.7mm;margin-left:17.5mm;margin-right:17.5mm;}
table{border-collapse:collapse;width:100%;margin:6px 0;table-layout:fixed;}
td,th{border:1px solid #000;padding:3px 6px;font-size:11pt;font-family:'Times New Roman',serif;vertical-align:middle;text-align:left;}
td[style*="text-align:right"]{text-align:right !important;}
td[style*="text-align:center"]{text-align:center !important;}
p{margin:0;padding:2px 0;line-height:1.67;font-family:'Times New Roman',serif;font-size:11pt;}
b,strong{font-weight:bold;}
ol{margin:4px 0;padding-left:24px;}
ol li{margin:2px 0;font-family:'Times New Roman',serif;font-size:11pt;line-height:1.67;}
</style></head><body>
${logoBase64 ? `<div class="header-logo"><img src="${logoBase64}" /></div>` : ''}
<div class="content">${processedHtml}</div>
</body></html>`

            this.isOdlukaPreview = true
            this.openReportPreview(styledHtml, this.$t('general.odlukaOUsvajanju'))
        },

        //IZVJESTAJ
        async downloadIzvjestajDocx(date) {
            const headerImageUrl = await this.getHeaderImage()
            const data = { Id: Number(localStorage.getItem('CompanyId')), LanguageId: Number(localStorage.getItem('LanguageId')), Date: date, StatusIds: [1, 2, 4] }
            const r = await this.$axios.post('Asset/ShowAssetPerKonto_Kumulativno', data)
            const podaci = r.data || []
            // Fetch za prijedlog rashoda OS
            const dataRashodOS = {
                Id: Number(localStorage.getItem('CompanyId')),
                LanguageId: Number(localStorage.getItem('LanguageId')),
                Date: date,
                StatusIds: [4]
            }
            const rRashodOS = await this.$axios.post('Asset/ShowAssetPerKonto_Kumulativno', dataRashodOS)
            const podaciRashodOS = rRashodOS.data || []

            // Fetch za sitni inventar
            const rSI = await this.$axios.post('SmallAsset/ShowSmallAssetPerKonto_Kumulativno', {
                Id: Number(localStorage.getItem('CompanyId')),
                LanguageId: Number(localStorage.getItem('LanguageId')),
                Date: date,
                StatusIds: [1, 2]
            })
            const podaciSI = rSI.data || {}

            // Fetch za prijedlog rashoda SI
            const rRashodSI = await this.$axios.post('SmallAsset/ShowSmallAssetPerKonto_Kumulativno', {
                Id: Number(localStorage.getItem('CompanyId')),
                LanguageId: Number(localStorage.getItem('LanguageId')),
                Date: date,
                StatusIds: [4]
            })
            const podaciRashodSI = rRashodSI.data || {}
            const totalRashodOS_Nabavna = podaciRashodOS.reduce((s, k) => s + Number(k.PurchaseValue || 0), 0)
            const totalRashodOS_Ispravka = podaciRashodOS.reduce((s, k) => s + Number(k.TotalDepreciation || 0), 0)
            const totalRashodOS_Sadasnja = podaciRashodOS.reduce((s, k) => s + Number(k.CurrentValue || 0), 0)
            if (!this.komisija) await this.fetchKomisija()
            const sviClanovi = this.komisija?.Members ? this.komisija.Members.split('\n').map(m => m.trim()).filter(Boolean) : []
            const predsjednik = sviClanovi[0] || ''
            const clanovi = sviClanovi.slice(1)
            const stanjeDan = new Date(date).toLocaleDateString('sr-Latn-BA')
            const godina = new Date().getFullYear()
            const font = 'Times New Roman'
            const sz = 22
            const border = { style: BorderStyle.SINGLE, size: 1, color: 'auto' }
            const borders = { top: border, bottom: border, left: border, right: border }
            const fmt = v => Number(v || 0).toLocaleString('sr-Latn-BA', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
            const p = (text, opts = {}) => new Paragraph({
                spacing: { line: 240 }, alignment: opts.align || AlignmentType.LEFT, numbering: opts.numbering || undefined,
                children: [new TextRun({ text: text || ' ', font, size: sz, bold: !!opts.bold })]
            })
            const empty = () => p(' ')
            const tc = (text, align = AlignmentType.CENTER, bold = false) => new TableCell({
                borders, margins: { top: 0, bottom: 0, left: 10, right: 10 },
                children: [new Paragraph({ alignment: align, children: [new TextRun({ text: text || '', font, size: sz, bold })] })]
            })
            const colWidths4 = [1791, 2213, 2258, 3644]
            const kontoBlock = konto => [
                p(`${this.$t('report.izvjestaj.konto')} ${konto.Category}`, { bold: true }),
                new Table({
                    width: { size: 9906, type: WidthType.DXA }, columnWidths: colWidths4,
                    rows: [
                        new TableRow({
                            children: [
                                tc(this.$t('report.izvjestaj.opis')),
                                tc(this.$t('report.izvjestaj.nabavna')),
                                tc(this.$t('report.izvjestaj.ispravka')),
                                tc(this.$t('report.izvjestaj.sadasnja'))
                            ]
                        }),
                        new TableRow({
                            children: [
                                tc(this.$t('report.izvjestaj.stanjePoKnjigama'), AlignmentType.LEFT),
                                tc(fmt(konto.PurchaseValue), AlignmentType.RIGHT),
                                tc(fmt(konto.TotalDepreciation), AlignmentType.RIGHT),
                                tc(fmt(konto.CurrentValue), AlignmentType.RIGHT)
                            ]
                        }),
                        new TableRow({
                            children: [
                                tc(this.$t('report.izvjestaj.stanjePoPopisu'), AlignmentType.LEFT),
                                tc(fmt(konto.PurchaseValue), AlignmentType.RIGHT),
                                tc(fmt(konto.DepreciationYear), AlignmentType.RIGHT),
                                tc(fmt(konto.ValuePrevYear), AlignmentType.RIGHT)
                            ]
                        }),
                    ]
                }),
                empty(),
            ]
            const komisijaRows = (align) => {
                const rows = [p(`${predsjednik}, ${this.$t('report.izvjestaj.predsjednik')} ____________________`, { align })]
                clanovi.forEach(c => { rows.push(p(`${c}, ${this.$t('report.izvjestaj.clan')} ____________________`, { align })) })
                return rows
            }
            const rashodTable = (nabavna, ispravka, sadasnja) => new Table({
                width: { size: 9906, type: WidthType.DXA }, columnWidths: colWidths4,
                rows: [
                    new TableRow({
                        children: [
                            tc(this.$t('report.izvjestaj.opis')),
                            tc(this.$t('report.izvjestaj.nabavna')),
                            tc(this.$t('report.izvjestaj.ispravka')),
                            tc(this.$t('report.izvjestaj.sadasnja'))
                        ]
                    }),
                    new TableRow({
                        children: [
                            tc(this.$t('report.izvjestaj.stanjePoKnjigama'), AlignmentType.LEFT),
                            tc(fmt(nabavna), AlignmentType.RIGHT),
                            tc(fmt(ispravka), AlignmentType.RIGHT),
                            tc(fmt(sadasnja), AlignmentType.RIGHT)
                        ]
                    }),
                    new TableRow({
                        children: [
                            tc(this.$t('report.izvjestaj.stanjePoPopisu'), AlignmentType.LEFT),
                            tc(fmt(nabavna), AlignmentType.RIGHT),
                            tc(fmt(ispravka), AlignmentType.RIGHT),
                            tc(fmt(sadasnja), AlignmentType.RIGHT)
                        ]
                    }),
                ]
            })
            const tudaTable = () => new Table({
                width: { size: 9906, type: WidthType.DXA }, columnWidths: [2721, 2511, 1664, 1510, 1500],
                rows: [
                    new TableRow({ children: [tc(this.$t('report.izvjestaj.invBroj')), tc(this.$t('report.izvjestaj.nazivSredstva')), tc(this.$t('report.izvjestaj.barKod')), tc(this.$t('report.izvjestaj.kolicina')), tc(this.$t('report.izvjestaj.lokacija'))] }),
                    new TableRow({ children: [tc(''), tc(''), tc(''), tc(''), tc('')] }),
                ]
            })
            let logoHeader
            try {
                const logoResponse = await fetch(headerImageUrl)
                if (!logoResponse.ok) throw new Error(this.$t('report.izvjestaj.logoError'))
                const logoArrayBuffer = await logoResponse.arrayBuffer()
                logoHeader = new Header({
                    children: [new Paragraph({ alignment: AlignmentType.CENTER, children: [new ImageRun({ data: logoArrayBuffer, transformation: { width: 530, height: 140 }, type: 'png' })] })]
                })
            } catch (e) {
                console.warn('Logo nije učitan:', e)
                logoHeader = new Header({ children: [new Paragraph({ children: [] })] })
            }
            const doc = new Document({
                numbering: { config: [{ reference: 'lista', levels: [{ level: 0, format: LevelFormat.DECIMAL, text: '%1.', alignment: AlignmentType.LEFT, style: { paragraph: { indent: { left: 720, hanging: 360 } } } }] }] },
                sections: [{
                    properties: { page: { size: { width: 11906, height: 16838 }, margin: { top: 720, right: 1000, bottom: 720, left: 1000 } } },
                    headers: { default: logoHeader },
                    children: [
                        p(`${this.$t('report.izvjestaj.sarajevo')} ${stanjeDan}`), p(this.$t('report.izvjestaj.broj')), p(this.$t('report.izvjestaj.generalnom')), empty(),
                        p(`${this.$t('report.izvjestaj.predmet')} ${stanjeDan} ${this.$t('report.izvjestaj.godine')}.`, { bold: true }), empty(),
                        p(`${this.$t('report.izvjestaj.komisijaTekst')} ##.##.####. ${this.$t('report.izvjestaj.godineusastavu')}`), empty(),
                        ...komisijaRows(AlignmentType.CENTER), empty(),
                        p(`${this.$t('report.izvjestaj.obavila')} ${stanjeDan}: `), empty(),
                        ...podaci.flatMap(k => kontoBlock(k)),
                        p(`${this.$t('report.izvjestaj.napomenaStalna')} ${godina}. ${this.$t('report.izvjestaj.godinu')} `), empty(),
                        p(this.$t('report.izvjestaj.sitniInventar'), { bold: true }),
                        new Table({
                            width: { size: 9906, type: WidthType.DXA }, columnWidths: colWidths4,
                            rows: [
                                new TableRow({
                                    children: [
                                        tc(this.$t('report.izvjestaj.opis')),
                                        tc(this.$t('report.izvjestaj.nabavna')),
                                        tc(this.$t('report.izvjestaj.ispravka')),
                                        tc(this.$t('report.izvjestaj.sadasnja'))
                                    ]
                                }),
                                new TableRow({
                                    children: [
                                        tc(this.$t('report.izvjestaj.stanjePoKnjigama'), AlignmentType.LEFT),
                                        tc(fmt(podaciSI.ukupnaNabavna), AlignmentType.RIGHT),
                                        tc(fmt(podaciSI.amortizacija), AlignmentType.RIGHT),
                                        tc(fmt(podaciSI.sadasnjaVrijednost), AlignmentType.RIGHT)
                                    ]
                                }),
                                new TableRow({
                                    children: [
                                        tc(this.$t('report.izvjestaj.stanjePoPopisu'), AlignmentType.LEFT),
                                        tc(fmt(podaciSI.ukupnaNabavna), AlignmentType.RIGHT),
                                        tc(fmt(podaciSI.amortizacija), AlignmentType.RIGHT),
                                        tc(fmt(podaciSI.sadasnjaVrijednost), AlignmentType.RIGHT)
                                    ]
                                }),
                            ]
                        }),
                        empty(), p(this.$t('report.izvjestaj.napomenaSitni')), empty(),
                        p(this.$t('report.izvjestaj.tudjaSredstva'), { bold: true }), tudaTable(), empty(),
                        p(this.$t('report.izvjestaj.prijedlogRashodaOS'), { bold: true }),
                        rashodTable(totalRashodOS_Nabavna, totalRashodOS_Ispravka, totalRashodOS_Sadasnja),
                        empty(),
                        p(this.$t('report.izvjestaj.prijedlogRashodaSI'), { bold: true }),
                        rashodTable(podaciRashodSI.ukupnaNabavna, podaciRashodSI.amortizacija, podaciRashodSI.sadasnjaVrijednost),
                        empty(),
                        p(this.$t('report.izvjestaj.uPrilogu')), empty(),
                        p(`${this.$t('report.izvjestaj.prilog1')} ${stanjeDan} ${this.$t('report.izvjestaj.godineSaZaduzenjima')}`, { numbering: { reference: 'lista', level: 0 } }),
                        p(this.$t('report.izvjestaj.prilog2'), { numbering: { reference: 'lista', level: 0 } }),
                        p(`${this.$t('report.izvjestaj.prilog3')} ${stanjeDan} ${this.$t('report.izvjestaj.godine')} `, { numbering: { reference: 'lista', level: 0 } }),
                        p(this.$t('report.izvjestaj.prilog4'), { numbering: { reference: 'lista', level: 0 } }),
                        p(this.$t('report.izvjestaj.prilog5'), { numbering: { reference: 'lista', level: 0 } }),
                        p(this.$t('report.izvjestaj.prilog6'), { numbering: { reference: 'lista', level: 0 } }),
                        p(this.$t('report.izvjestaj.prilog7'), { numbering: { reference: 'lista', level: 0 } }),
                        p(this.$t('report.izvjestaj.prilog8'), { numbering: { reference: 'lista', level: 0 } }),
                        empty(),
                        ...komisijaRows(AlignmentType.RIGHT),
                    ]
                }]
            })
            const blob = await Packer.toBlob(doc)
            const d = new Date()
            const dateStr = String(d.getDate()).padStart(2, '0') + String(d.getMonth() + 1).padStart(2, '0') + d.getFullYear()
            this._izvjestajBlob = blob
            this._izvjestajFileName = `${this.$t('report.izvjestaj.fileName')}_${dateStr}.docx`
            const arrayBuffer = await blob.arrayBuffer()
            const result = await mammoth.convertToHtml({ arrayBuffer, options: { includeDefaultStyleMap: true } })

            const komisijaBrojClanova = sviClanovi.length

            let processedHtml = result.value
                .replace(/<p>([^<]*____________________[^<]*)<\/p>/g,
                    '<p class="komisija-red" style="text-align:center;">$1</p>')
                .replace(/(<td>)(<p>)(\d[\d.]*,\d{2})(<\/p><\/td>)/g,
                    '<td style="text-align:right;"><p>$3</p></td>')
                .replace(/(<td>)(<p><strong>)(\d[\d.]*,\d{2})(<\/strong><\/p><\/td>)/g,
                    '<td style="text-align:right;"><p><strong>$3</strong></p></td>')

            const ukupnoRedova = [...processedHtml.matchAll(/<p class="komisija-red"/g)].length
            const pocetakDesnih = ukupnoRedova - komisijaBrojClanova
            let brojac = 0
            processedHtml = processedHtml.replace(
                /<p class="komisija-red" style="text-align:center;">/g,
                () => {
                    brojac++
                    return brojac > pocetakDesnih
                        ? '<p style="text-align:right;">'
                        : '<p style="text-align:center;">'
                }
            )

            let logoBase64 = ''
            try {
                const logoResponse = await fetch(headerImageUrl)
                const logoBlob = await logoResponse.blob()
                logoBase64 = await new Promise(resolve => {
                    const reader = new FileReader()
                    reader.onload = () => resolve(reader.result)
                    reader.readAsDataURL(logoBlob)
                })
            } catch (e) { console.warn('Logo nije učitan za preview') }

            const styledHtml = `<!DOCTYPE html><html><head><meta charset="UTF-8"><style>
@page{size:A4 portrait;}
*{box-sizing:border-box;margin:0;padding:0;}
.header-logo{position:fixed;top:0;left:0;right:0;text-align:center;background:white;}
.header-logo img{width:100%;max-width:530px;height:140px;object-fit:contain;}
.content{margin-top:160px;}
body{font-family:'Times New Roman',serif;font-size:11pt;line-height:1.67;color:#000;margin-top:12.7mm;margin-bottom:12.7mm;margin-left:17.5mm;margin-right:17.5mm;}
table{border-collapse:collapse;width:100%;margin:6px 0;table-layout:fixed;}
td,th{border:1px solid #000;padding:3px 6px;font-size:11pt;font-family:'Times New Roman',serif;vertical-align:middle;text-align:left;}
td[style*="text-align:right"]{text-align:right !important;}
td[style*="text-align:center"]{text-align:center !important;}
p{margin:0;padding:2px 0;line-height:1.67;font-family:'Times New Roman',serif;font-size:11pt;}
b,strong{font-weight:bold;}
ol{margin:4px 0;padding-left:24px;}
ol li{margin:2px 0;font-family:'Times New Roman',serif;font-size:11pt;line-height:1.67;}
</style></head><body>
${logoBase64 ? `<div class="header-logo"><img src="${logoBase64}" /></div>` : ''}
<div class="content">${processedHtml}</div>
</body></html>`

            this.isOdlukaPreview = true
            this.openReportPreview(styledHtml, this.$t('izvjestaji.4Upper'))
        },

        async fetchKomisija() {
            try {
                var data = {
                    Id: Number(localStorage.getItem('CompanyId')),
                    LanguageId: Number(localStorage.getItem('LanguageId'))
                }
                const r = await this.$axios.post('Komisije/ShowActive', data)
                this.komisija = Array.isArray(r.data) ? r.data[0] : r.data
            } catch (err) {
                console.error(this.$t('general.noData'), err)
                this.komisija = null
            }
        },


        openReportPreview(html, title) {
            this.reportTitle = title
            this.reportPreview = true
            this.$nextTick(() => {
                const iframe = this.$refs.reportFrame
                const doc = iframe.contentWindow.document
                doc.open()
                doc.write(html)
                doc.close()
            })
        },

        printReport() {
            this.$refs.reportFrame.contentWindow.print()
        },

        downloadPDF() {
            if (this._izvjestajBlob) {
                const url = URL.createObjectURL(this._izvjestajBlob)
                const link = document.createElement('a')
                link.href = url
                link.download = this._izvjestajFileName
                document.body.appendChild(link)
                link.click()
                link.remove()
                URL.revokeObjectURL(url)
                this._izvjestajBlob = null
                this._izvjestajFileName = null
                return
            }
            const container = document.createElement("div")
            container.innerHTML = this.html
            const title = container.querySelector("h2")?.innerText
            const fileName = this.generateReportFileName(title)
            html2pdf().set({
                margin: 10, filename: fileName,
                html2canvas: { scale: 2 },
                jsPDF: { unit: "mm", format: "a4", orientation: "landscape" }
            }).from(container).save()
        },

        generateReportFileName(title) {
            const date = new Date()
            const day = String(date.getDate()).padStart(2, '0')
            const month = String(date.getMonth() + 1).padStart(2, '0')
            const year = date.getFullYear()
            const formattedDate = `${day}${month}${year}`
            const cleanTitle = title
                .replaceAll(" ", "_").replaceAll("č", "c").replaceAll("ć", "c")
                .replaceAll("ž", "z").replaceAll("š", "s").replaceAll("đ", "d")
            return `${cleanTitle}_${formattedDate}.pdf`
        },


        // ── MODAL ZA DODAVANJE 
        openNewPopis() {
            const otvoreni = this.popisi.filter(p => p.Status === false)
            if (otvoreni.length > 0) {
                this.$store.dispatch('NOTIF_WARNING', {
                    poruka: this.$t('modalni.popis.vecPostojiOtvoren'),
                    position: 'center',
                    icon: 'error',
                    timer: 4500,
                    width: '550'
                })
                return
            }
            this.resetForm()
            this.fetchKomisija()
            this.dialog = true
            this.$nextTick(() => {
                this.$refs.popisForm?.resetValidation()
            })
        },

        closeDialog() {
            this.dialog = false
            this.editMode = false
            this.editId = null
            this.resetForm()
            this.$nextTick(() => {
                this.$refs.popisForm?.resetValidation()
            })
        },

        resetForm() {
            this.form = { Name: '', Date: null, Documents: [null], DocumentNames: [''] }
            this.datumUpozorenje = false
        },

        async savePopis() {
            const { valid } = await this.$refs.popisForm.validate()
            if (!valid) return
            try {
                const now = new Date();

                // UPLOAD FILE
                (now.getUTCMonth() + 1) < 10 ? this.mjesec = "0" + (now.getUTCMonth() + 1) : this.mjesec = (now.getUTCMonth() + 1);
                now.getUTCDate() < 10 ? this.dan = "0" + now.getUTCDate() : this.dan = now.getUTCDate();
                this.godina = now.getUTCFullYear().toString().slice(-2);
                now.getHours() < 10 ? this.sat = "0" + now.getHours() : this.sat = now.getHours();
                now.getMinutes() < 10 ? this.minut = "0" + now.getMinutes() : this.minut = now.getMinutes();
                now.getSeconds() < 10 ? this.sekunda = "0" + now.getSeconds() : this.sekunda = now.getSeconds();
                this.NazivFajla = this.mjesec + this.dan + this.godina + this.sat + this.minut + this.sekunda;

                if (this.editMode) {
                    // ── EDIT
                    const r = await this.$axios.put('Popis/Edit', {
                        Id: this.editId,
                        Name: this.form.Name,
                        AddDate: this.form.Date ? new Date(this.form.Date).toISOString() : new Date().toISOString(),
                        CompanyId: Number(localStorage.getItem('CompanyId')),
                        KomisijaId: this.komisija?.KomisijaId || null
                    })

                    if (r.data === 'UPDATED') {
                        // Upload više dokumenata
                        const validDocs = this.form.Documents
                            .map((doc, i) => ({ doc, name: this.form.DocumentNames[i] }))
                            .filter(x => x.doc !== null)

                        for (let i = 0; i < validDocs.length; i++) {
                            const { doc, name } = validDocs[i]
                            const now2 = new Date()
                            const m = String(now2.getUTCMonth() + 1).padStart(2, '0')
                            const d = String(now2.getUTCDate()).padStart(2, '0')
                            const y = now2.getUTCFullYear().toString().slice(-2)
                            const h = String(now2.getHours()).padStart(2, '0')
                            const min = String(now2.getMinutes()).padStart(2, '0')
                            const s = String(now2.getSeconds()).padStart(2, '0')
                            const ext = doc.name.split('.').pop()
                            const fileName = `Popis_${localStorage.getItem('CountryId')}_${localStorage.getItem('CompanyId')}_${m}${d}${y}${h}${min}${s}${i}.${ext}`

                            const file = new File([doc], fileName, { type: doc.type })
                            const formData = new FormData()
                            formData.append('file', file)
                            await this.$axios.post('Upload/', formData)

                            await this.$axios.post('Popis/AddDokument', {
                                PopisId: this.editId,
                                Name: name || fileName,
                                FileName: fileName,
                                CompanyId: Number(localStorage.getItem('CompanyId'))
                            })
                        }

                        this.editMode = false
                        this.editId = null

                        this.$store.dispatch('NOTIF_SUCCESS', {
                            poruka: this.$t('modalni.popis.uspjesnoEditovan'),
                            position: 'top-end',
                            timer: 2500,
                            action: 'noreload'
                        })
                        this.dialog = false
                        await this.fetchPopisi()
                    } else {
                        this.$store.dispatch('NOTIF_WARNING', {
                            poruka: this.$t('popis.greskaDodavanja'),
                            position: 'center',
                            icon: 'error',
                            timer: 4500,
                            width: '550'
                        })
                    }

                } else {
                    // ── ADD
                    const data = {
                        Name: this.form.Name,
                        AddDate: this.form.Date ? new Date(this.form.Date).toISOString() : new Date().toISOString(),
                        Status: false,
                        CompanyId: Number(localStorage.getItem('CompanyId')),
                        KomisijaId: this.komisija?.KomisijaId || null
                    }
                    const r = await this.$axios.post('Popis/Add', data)
                    const newPopisId = r.data // sada je broj, ne string

                    if (newPopisId) {
                        const validDocs = this.form.Documents
                            .map((doc, i) => ({ doc, name: this.form.DocumentNames[i] }))
                            .filter(x => x.doc !== null)

                        for (let i = 0; i < validDocs.length; i++) {
                            const { doc, name } = validDocs[i]
                            const now2 = new Date()
                            const m = String(now2.getUTCMonth() + 1).padStart(2, '0')
                            const d = String(now2.getUTCDate()).padStart(2, '0')
                            const y = now2.getUTCFullYear().toString().slice(-2)
                            const h = String(now2.getHours()).padStart(2, '0')
                            const min = String(now2.getMinutes()).padStart(2, '0')
                            const s = String(now2.getSeconds()).padStart(2, '0')
                            const ext = doc.name.split('.').pop()
                            const fileName = `Popis_${localStorage.getItem('CountryId')}_${localStorage.getItem('CompanyId')}_${m}${d}${y}${h}${min}${s}${i}.${ext}`

                            // Upload fajla
                            const file = new File([doc], fileName, { type: doc.type })
                            const formData = new FormData()
                            formData.append('file', file)
                            await this.$axios.post('Upload/', formData)

                            // Zapis dokumenta sa nazivom
                            await this.$axios.post('Popis/AddDokument', {
                                PopisId: newPopisId,
                                Name: name || fileName,
                                FileName: fileName,
                                CompanyId: Number(localStorage.getItem('CompanyId'))
                            })
                        }

                        this.$store.dispatch('NOTIF_SUCCESS', {
                            poruka: this.$t('modalni.popis.uspjesnoDodat'),
                            position: 'top-end',
                            timer: 2500,
                            action: 'noreload'
                        })
                        this.dialog = false
                        await this.fetchPopisi()
                    } else {
                        this.$store.dispatch('NOTIF_WARNING', {
                            poruka: this.$t('modalnipopis.greskaDodavanja'),
                            position: 'center',
                            icon: 'error',
                            timer: 4500,
                            width: '550'
                        })
                    }
                }

            } catch (err) {
                console.error(err)
            }
        },
        // ── MODAL ZA BRISANJE 
        openDeleteDialog(item) {
            this.deletePopisId = item.Id
            this.deletePopisName = item.Name
            this.deleteDialog = true
        },

        async confirmDelete() {
            if (!this.deletePopisId) return
            try {
                var data = {
                    Id: this.deletePopisId,
                    CompanyId: Number(localStorage.getItem('CompanyId'))
                }
                const r = await this.$axios.put('Popis/Delete', data)
                if (r.data === 'UPDATED') {
                    this.$store.dispatch('NOTIF_SUCCESS', {
                        poruka: this.$t('modalni.popis.uspjesnoObrisan'),
                        position: 'top-end',
                        timer: 2500,
                        action: 'noreload'
                    })
                    await this.fetchPopisi()
                }
            } catch (err) {
                this.$store.dispatch('NOTIF_WARNING', {
                    poruka: this.$t('modalni.popis.greskaBrisanja'),
                    position: 'center',
                    icon: 'error',
                    timer: 4500,
                    width: '550'
                })
            } finally {
                this.deleteDialog = false
                this.deletePopisId = null
                this.deletePopisName = ''
            }
        },

        // NAVIGACIJA 
        async pregledaj(item) {
            this.$router.push({ name: 'PopisPreview', params: { id: item.Id } })
        },
        async edituj(item) {
            this.editMode = true
            this.editId = item.Id
            this.form = {
                Name: item.Name,
                Date: item.Date,
                Documents: [null],
                DocumentNames: ['']
            }
            this.fetchKomisija()
            this.dialog = true
            this.$nextTick(() => {
                this.$refs.popisForm?.resetValidation()
            })
        },
    }
}
</script>

<style scoped>
.doc-link {
    color: rgb(var(--v-theme-primary));
    text-decoration: none;
    font-size: 13px;
    display: flex;
    align-items: center;
}

.doc-link:hover {
    text-decoration: underline;
}

.doc-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 6px 0;
    border-bottom: 1px solid #e5e7eb;
}

.doc-row:last-child {
    border-bottom: none;
}

.doc-link {
    display: flex;
    align-items: center;
    gap: 4px;
    text-decoration: none;
    color: #0281CA;

    flex: 1;
    /* 🔥 važno za layout */
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
}

.doc-actions {
    display: flex;
    align-items: center;
    gap: 4px;
}
</style>